import { Button } from '@tryhackme/thm-ui-components';
import { useAppSelector } from 'src/app/hooks';
import { store } from 'src/app/store';
import { setOpenWarnModal, setShouldBlockerProceed, setShouldClearBlocker } from 'src/app/reducers/manage-room.reducer';
import { ModalLayout } from '../modal';
import { StyledLoadingSpinner, StyledWarnMessage } from './unsaved-warn-modal.styles';
import { UnSavedWarnModalProps } from './unsaved-warn-modal.types';
const handleOpenChange = (value: boolean) => {
  store.dispatch(setOpenWarnModal(value));
  store.dispatch(setShouldClearBlocker(!value));
};
export const UnSavedWarnModal = ({
  isRoomCodeFieldChanged,
  handleDiscardChanges,
  handleActionButton,
  isSavingChanges = false,
  customWarningMessage
}: UnSavedWarnModalProps) => {
  const {
    openWarnModal
  } = useAppSelector(state => state.manageRoom);
  const handleAction = () => {
    handleActionButton();
    store.dispatch(setOpenWarnModal(false));
    store.dispatch(setShouldBlockerProceed(true));
  };
  const handleDiscard = () => {
    handleDiscardChanges();
    store.dispatch(setShouldBlockerProceed(true));
  };
  return <ModalLayout open={openWarnModal} openChange={handleOpenChange} showTriggerElement={false} modalTitleText="You have unsaved changes" closeButtonText="Discard changes" showWarnBox={Boolean(isRoomCodeFieldChanged)} warnBoxText={`You have made changes to the room code.The room code determines the room's url, so updating
       it will invalidate the current URL. If you have shared room links with people, you will have to update them.`} handleCloseButtonAction={handleDiscard} actionElement={<Button onClick={handleAction}>
          {isSavingChanges && <StyledLoadingSpinner color="#151C2B" />}
          {isSavingChanges ? 'Saving changes...' : 'Save changes'}
        </Button>} actionButtonText="Save changes" data-sentry-element="ModalLayout" data-sentry-component="UnSavedWarnModal" data-sentry-source-file="unsaved-warn-modal.tsx">
      <StyledWarnMessage data-sentry-element="StyledWarnMessage" data-sentry-source-file="unsaved-warn-modal.tsx">
        {customWarningMessage ?? <>
            You have made changes but you are about to leave this page? <br />
            Do you want to save your changes and update this room?
          </>}
      </StyledWarnMessage>
    </ModalLayout>;
};